import angular from 'angular';

import angularResource from 'angular-resource';

import request from './services/request';
import dates from './services/dates';

export default angular.module('utils', [angularResource])
    .service('dates', dates)
    .factory('requestService', request)
    .name;



// WEBPACK FOOTER //
// ./utils/utils-module.js